import { useEffect } from 'react';
import { useSettingsStore } from '../stores/settingsStore';

// Testi e riconoscimento dell'errore stanno in lib/ai/aiDisabled (senza dipendenze dallo store).
export {
  AI_DISABLED_TOOLTIP,
  AI_DISABLED_MESSAGE,
  isAiDisabledError,
  aiDisabledFromInvokeError,
  notifyAiDisabled,
} from '../ai/aiDisabled';

/**
 * Interruttore IA dell'azienda (settings.ai_customer_data_enabled, migration
 * 20261021b_interruttore_ia.sql). Spento = nessuna funzione IA legge Lead, Clienti, Offerte,
 * chiamate, email, WhatsApp e note dell'azienda: i pulsanti IA con dati cliente vanno mostrati
 * disabilitati con AI_DISABLED_TOOLTIP. Il blocco vero sta nel server (edge e flusia-core):
 * qui e' solo l'interfaccia.
 *
 * Colonna assente (database non ancora migrato) o impostazioni non caricate = acceso.
 */

function readFlag(settings: unknown): boolean {
  return (settings as { ai_customer_data_enabled?: boolean | null } | null)?.ai_customer_data_enabled !== false;
}

export function useOrgAiEnabled(): boolean {
  const settings = useSettingsStore((s) => s.settings);
  const fetchSettings = useSettingsStore((s) => s.fetchSettings);
  useEffect(() => {
    if (!settings) void fetchSettings();
  }, [settings, fetchSettings]);
  return readFlag(settings);
}

/** Per store e servizi fuori da React: valore attuale dalle impostazioni gia' caricate. */
export function isOrgAiEnabledNow(): boolean {
  return readFlag(useSettingsStore.getState().settings);
}
